import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";
import { TRANSFER_ORDER_TYPE } from "constants/order";
import fetch from "../auth/FetchInterceptor";

const ajaxService = {};

ajaxService.getGroupLocationList = ({ }) => {
  return fetch({
    url: `${env.API_MSP}/groups/out/list`,
    method: "get",
  });
};

ajaxService.getAjax = ({
  countryId,
  type,
  parent_code,
  record_status = "O",
}) => {
  return fetch({
    url: `${env.API_MSP}/ajax/localities?id_country=${countryId}&type=${type}&parent_code=${parent_code}&record_status=${record_status}`,
    method: "get",
  });
};

ajaxService.getListFreeWard = ({
  countryId,
  order_type,
  parent_code,
  center_id,
}) => {
  return fetch({
    url: `${env.API_MSP}/ajax/list-free-ward?id_country=${countryId}&order_type=${order_type}&parent_code=${parent_code}&center_id=${center_id}`,
    method: "get",
  });
};

ajaxService.getShippingUnitList = () => {
  return fetch({
    url: `${env.API_MSP}/ajax/shipping-units`,
    method: "get",
  });
};
ajaxService.getLocationsByCustomer = ({ customerId, params }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/locations-by-customer/${customerId}`,
    method: "get",
    params: {
      page: -1,
      location_type: params?.location_type || "",
      keywords: params?.keywords || "",
      expand: params?.expand || "",
      sort: "-checker_date",
    },
  });
};
ajaxService.getResourceType = () => {
  return fetch({
    url: `${env.API_MSP}/ajax/resource-type`,
    method: "get",
  });
};

ajaxService.shippingUnits = () => {
  return fetch({
    url: `${env.API_MSP}/ajax/shipping-units`,
    method: "get",
  });
};

ajaxService.shippingUnitsAll = () => {
  return fetch({
    url: `${env.API_MSP}/ajax/shipping-units-all`,
    method: "get",
  });
};
ajaxService.getRunnerByRule = ({
  action_date,
  time_slot,
  province_code,
  district_code,
  ward_code,
  hub_id,
}) => {
  return fetch({
    url: `${env.API_MSP}/ajax/runner-by-rule`,
    method: "get",
    params: {
      action_date,
      time_slot,
      province_code,
      district_code,
      ward_code,
      hub_id,
    },
  });
};
ajaxService.getCustomerShippingType = ({ customerId }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/customer-shipping-type/${customerId}`,
    method: "get",
  });
};
ajaxService.getListSale = ({ customerId }) => {
  return fetchV2({
    url: `${env.API_MSP}/customers/${customerId}/sale`,
    method: "get",
    params: {
      page: -1,
    },
  });
};
ajaxService.changePassword = ({ data }) => {
  return fetchV2({
    url: `${env.API_MSP}/my/change-password`,
    method: "post",
    data: {
      ...data,
    },
  });
};

/**
 * List Locality
 * @param {{
 *  countryId: number;
 *  type: number;
 *  parentCode: string;
 *  record_status: string;
 * }} val
 */
ajaxService.listLocality = ({
  countryId,
  type,
  parentCode,
  record_status = "O",
}) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/localities`,
    method: "get",
    params: {
      id_country: countryId,
      type,
      parent_code: parentCode,
      record_status,
    },
  });
};

ajaxService.getCustomerLocationTransports = ({
  customer_id,
  province_code,
  district_code,
  ward_code,
  order_type,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/customer-location-transport/${customer_id}`,
    method: "get",
    params: {
      order_type: order_type || TRANSFER_ORDER_TYPE.RECEIVE,
      province_code: province_code,
      district_code: district_code,
      ward_code: ward_code,
      expand: "hub",
    },
  });
};

ajaxService.listTicketAssignees = (options = {}) => {
  const { keywords, page = 1, per_page = 20 } = options;
  const normalizedKeywords = String(keywords ?? "").trim();

  return fetchV2({
    url: `${env.API_MSP}/ajax/ticket-assignees`,
    method: "get",
    params: {
      page,
      per_page,
      ...(normalizedKeywords !== "" ? { keywords: normalizedKeywords } : {}),
    },
  });
};

export default ajaxService;
